import PicabooConstants from '../common/PicabooConstants';

//Look at test/utils/navigation.test.js for tests.
export function canNavigate(
  sections,
  currentSectionID,
  currentSection,
  currentPages,
  permissions,
  projectPK,
  previewMode,
) {
  let isFirstPageInSection = false;
  let isFirstPageInBook = false;
  let isLastPage = false;
  let canGoForward = true;
  let canGoBack = true;
  let forwardLocked = false;
  let backLocked = false;

  let isFirstSection = Object.keys(sections)[0] === currentSectionID;
  if (currentSection && currentSection.spreads) {
    let filteredSpreads = currentSection.spreads.filter((s, i) => {
      //Don't look at last spread if it is just the inside cover
      return !(
        s.pageCount === '0' ||
        (s.pageCount === '1' &&
          s.pages.length === 1 &&
          s.pages[0].pageType === PicabooConstants.PAGE_TYPES.COVER)
      );
    });
    filteredSpreads.forEach((spread, index, spreads) => {
      spread.pages.forEach((bookPage) => {
        if (currentPages.hasOwnProperty(bookPage.pageID)) {
          if (index === 0) {
            isFirstPageInSection = true;
          }

          if (index === 0 && isFirstSection) {
            isFirstPageInBook = true;
          }

          if (index === spreads.length - 1) {
            isLastPage = true;
          }
        }
      });
    });
  }

  if (permissions) {
    if (isFirstPageInBook) {
      canGoBack = false;
    } else if (isFirstPageInSection) {
      const sectionKeys = Object.keys(sections);
      sectionKeys.forEach((key, index) => {
        if (key === currentSectionID) {
          if (index === 0) {
            canGoBack = false;
          } else {
            const previousSection = sections[sectionKeys[index - 1]];
            canGoBack = true;
            backLocked = previousSection.isLocked !== 0;
          }
        }
      });
    }
    if (isLastPage) {
      const sectionKeys = Object.keys(sections);
      sectionKeys.forEach((key, index) => {
        if (key === currentSectionID) {
          if (index === sectionKeys.length - 1) {
            canGoForward = false;
          } else {
            const nextSection = sections[sectionKeys[index + 1]];
            canGoForward =
              previewMode ||
              permissions.sectionPermissions[sectionKeys[index + 1]].canEdit;
            // && nextSection.isLocked === 0
            forwardLocked = nextSection.isLocked !== 0;
          }
        }
      });
    }
  }
  return { canGoForward, canGoBack, backLocked, forwardLocked };
}
